// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#mw .share-dashoard-dialog__section-title {
    margin-left: 12px;
}

#mw .share-dashboard-dialog__link-container {
    margin: 12px 2px 24px 2px;
}

#mw #share-dialog__save-password__button {
    margin: 16px 2px 8px 0 !important;
}

#mw #sharable-dashboard__link-input {
    margin-bottom: 8px;
}
#mw #sharable-dashboard__link-input > .md-errors-spacer {
    display: none;
}

#mw #sharable-dashboard__open-link {
    color: #34b7bd;
    margin-bottom: 20px;
}

#mw .share-dashoard-dialog__success-text {
    color: green;
    text-align: right;
    padding-right: 24px;
}

#mw #share-dialog.mw-mini-modal {
    height: auto;
}

#mw #share-dialog md-input-container {
    padding: 2px;
}

#mw #share-dialog md-input-container label {
    padding-left: 3px;
}

#mw #share-dialog .share-dashboard-dialog__link-container button {
    margin-right: 0px;
}`, "",{"version":3,"sources":["webpack://./public/js/components/builder/share-dialog.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["\n#mw .share-dashoard-dialog__section-title {\n    margin-left: 12px;\n}\n\n#mw .share-dashboard-dialog__link-container {\n    margin: 12px 2px 24px 2px;\n}\n\n#mw #share-dialog__save-password__button {\n    margin: 16px 2px 8px 0 !important;\n}\n\n#mw #sharable-dashboard__link-input {\n    margin-bottom: 8px;\n}\n#mw #sharable-dashboard__link-input > .md-errors-spacer {\n    display: none;\n}\n\n#mw #sharable-dashboard__open-link {\n    color: #34b7bd;\n    margin-bottom: 20px;\n}\n\n#mw .share-dashoard-dialog__success-text {\n    color: green;\n    text-align: right;\n    padding-right: 24px;\n}\n\n#mw #share-dialog.mw-mini-modal {\n    height: auto;\n}\n\n#mw #share-dialog md-input-container {\n    padding: 2px;\n}\n\n#mw #share-dialog md-input-container label {\n    padding-left: 3px;\n}\n\n#mw #share-dialog .share-dashboard-dialog__link-container button {\n    margin-right: 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
